export default __webpack_public_path__ + "static/media/premium-web.699c701f.png";